import { RowDataSplashScreen } from "../../components/SplashScreenPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the PDFPriceListTable factory
 */
class SplashScreenRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/splash-screen/read-range"
        this.accessData = "splashScreens"
    }

    create(splashScreen: any): RowDataSplashScreen {
        const rowDataPDFPriceList: RowDataSplashScreen = {
            id: splashScreen.id,
            title: splashScreen.title,
            img_url: splashScreen.img_url,
            isVisible: splashScreen.isVisible,
            action: "",
        };
        return rowDataPDFPriceList;
    }
}

let splashScreenRow: SplashScreenRow | null = null;

export default function getSplashScreenRow(): SplashScreenRow {
    if (splashScreenRow === null)
        splashScreenRow = new SplashScreenRow()
    return splashScreenRow
}